/**
 *  Functions that modify/change functions to enhance them
 */
var functions = {

    /**
     * Return a function that calls func only once after "delay" merging multiple calls
     */
    debounce: function(func, delay, context) {
        var handle;
        var res = function() {
            clearTimeout(handle);
            handle = setTimeout(function() {
                func.call(context);
            }, delay);
        };
        res.stop = function() {
            clearTimeout(handle);
        };
        res.force = function() {
            clearTimeout(handle);
            handle = setTimeout(function() {
                func.call(context);
            }, 0);
        };
        return res;
    },

    /**
     * Debounce a function so that it is called only once per animation frame.
     */
    debounceAnimate: function(func, context) {
        var handle;
        var res = function() {
            cancelAnimationFrame(handle);
            handle = requestAnimationFrame(function() {
                func.call(context);
            });
        };
        return res;
    },

    /**
     * Returns a function that calls func only once until delay has elapsed.
     * @param func
     * @param delay
     */
    limit: function(func, delay, context) {
        var paused = false;
        return function() {
            if (paused == false) {
                paused = true;
                setTimeout(function() {
                    paused = false;
                }, delay)
                return func.apply(context, arguments);
            }
        }
    },

    /**
     * Exactly like the limit method, except that it waits until all code has stopped executing to call the function
     */
    limitDelay: function() {
        var limited = this.limit.apply(this, arguments);
        return function() {
            setTimeout(limited, 0);
        }
    }
};
export default functions;
